import clsx from 'clsx';
import { useEffect, useRef } from 'react';

import { JobDetailsType } from '@/features/strapi/types';
import { useInView } from '@/hooks/useInView';

import { TextBlock } from '../text-block/TextBlock.component';

import styles from './AnchorArticle.module.scss';

export const AnchorArticle = ({
    content,
    setActive,
}: {
    content: JobDetailsType;
    setActive?: (id: string) => void;
}) => {
    const ref = useRef<HTMLDivElement>(null);
    const { inView } = useInView({ ref: ref, onlyOnce: true });

    useEffect(() => {
        const handleScroll = () => {
            if (!ref.current) return;

            const sectionTop = ref.current.offsetTop;

            if (window.scrollY + 100 >= sectionTop && sectionTop >= window.scrollY) {
                setActive && setActive(content.anchor);
            }
        };

        if (setActive) {
            window.addEventListener('scroll', handleScroll);
        }

        return () => window.removeEventListener('scroll', handleScroll);
    }, [content.anchor, setActive, ref]);

    return (
        <div
            id={content.anchor}
            ref={ref}
            className={clsx(styles.articleWrapper, {
                [styles.onlyDescription]: !content.title && !content.subtitle,
                [styles.animate]: inView,
            })}
        >
            <div className={styles.headline}>
                {content.title && <h3>{content.title}</h3>}
                {content.subtitle && <h5>{content.subtitle}</h5>}
            </div>
            {content.description && (
                <TextBlock className={styles.description} content={content.description} />
            )}
        </div>
    );
};
